import script from "./CurrencyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyInput.vue?vue&type=style&index=0&id=9029de20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9029de20"]])

export default __exports__